import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import 'roboto-fontface/css/roboto/roboto-fontface.css';
import './assets/tachyons.min.css';
import './assets/oc-scroll.css';
import './registerServiceWorker';

import App from './App.vue';
import router from './router';
import store from './store/index';

// Vue.config.productionTip = false;

Vue.use(Vuetify);

// @ts-ignore
import VueIntercom from 'vue-intercom';
Vue.use(VueIntercom, { appId: CONSTANTS.intercomAppId });

// @ts-ignore
import Datetime from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';

Vue.use(Datetime);

Vue.filter('toCurrency', (value: string) => {
  let val: any = value;
  if (typeof value === 'string') {
    val = parseFloat(value);
  } else if (typeof value !== 'number') {
    return value;
  }
  const formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
  });
  return formatter.format(val);
});

Vue.filter('toNumber', (value: string) => {
  const formatter = new Intl.NumberFormat('pt-BR');
  return formatter.format(Number.parseFloat(value));
});

import VueTheMask from 'vue-the-mask';
import { CONSTANTS } from './config/constants';
import IconSVG from '@/components/IconSVG.vue';
import InputUnmask from '@/components/InputUnmask.vue';
import { defaultIcons } from '@/services/IconService';
import { getFeatureFlag } from './services/FeatureFlagService';

import pt from 'vuetify/src/locale/pt';

Vue.component('icon-svg', IconSVG);
Vue.component('input-unmask', InputUnmask);
Vue.use(VueTheMask);

const opts = {
  icons: {
    iconfont: 'mdiSvg' as any,
    values: {
      ...defaultIcons,
    },
  },
  theme: {
    themes: {
      light: {
        primary: '#1E59F8',
        secondary: '#464646',
        accent: '#1E59F8',
      },
    },
  },
  lang: {
    locales: { pt },
    current: 'pt',
  },
};

new Vue({
  router,
  store,
  render: (h) => h(App),
  vuetify: new Vuetify(opts),
}).$mount('#app');

Vue.directive('feature', {
  update: (el, binding) => {
    getFeatureFlag(binding.value) ? el.style.display = '' : el.style.display = 'none';
  },
});
